export default __webpack_public_path__ + "static/media/back-to-the-future.366aa39a.jpg";